var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64385 0.250977C9.21697 0.250977 9.76662 0.478649 10.1719 0.883908C10.5771 1.28917 10.8048 1.83882 10.8048 2.41194L10.8048 8.71475C10.8048 9.28787 10.5771 9.83752 10.1719 10.2428C9.76662 10.648 9.21697 10.8757 8.64385 10.8757L2.16096 10.8757C1.58783 10.8757 1.03818 10.648 0.632924 10.2428C0.227665 9.83753 -7.95668e-06 9.28788 -8.05689e-06 8.71475L-9.15891e-06 2.41194C-9.25912e-06 1.83882 0.227663 1.28917 0.632922 0.88391C1.03818 0.47865 1.58783 0.250978 2.16095 0.250978L8.64385 0.250977ZM9.72433 2.41194C9.72433 2.12538 9.61049 1.85055 9.40786 1.64792C9.20523 1.44529 8.93041 1.33146 8.64385 1.33146L2.16095 1.33146C1.87439 1.33146 1.59957 1.4453 1.39694 1.64793C1.19431 1.85056 1.08047 2.12538 1.08047 2.41194L1.08047 8.71475C1.08047 9.00131 1.19431 9.27614 1.39694 9.47877C1.59957 9.6814 1.87439 9.79523 2.16096 9.79523L8.64385 9.79523C8.93041 9.79523 9.20523 9.6814 9.40786 9.47877C9.61049 9.27614 9.72433 9.00131 9.72433 8.71475L9.72433 2.41194Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9629 1.87139C12.9629 1.49208 12.863 1.11944 12.6734 0.790944C12.4837 0.462446 12.2109 0.18966 11.8824 1.88917e-07L11.8824 9.25469C11.8824 9.97109 11.5978 10.6582 11.0912 11.1647C10.5847 11.6713 9.89761 11.9559 9.18121 11.9559L2.44764 11.9559C2.6373 12.2844 2.91009 12.5572 3.23859 12.7468C3.56708 12.9365 3.93972 13.0364 4.31904 13.0364L9.18121 13.0364C10.1842 13.0364 11.1461 12.6379 11.8553 11.9287C12.5645 11.2195 12.9629 10.2577 12.9629 9.25469L12.9629 1.87139Z",
    fill: "#F6F6F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCopyIcon);
export default __webpack_public_path__ + "static/media/smallCopyIcon.a8bbbc129f2f4b19b4637d6c968b7da7.svg";
export { ForwardRef as ReactComponent };